module.exports = __webpack_public_path__ + "media/images/payment/seal-94d4cc0ce0845e2983d174d3d89e57ed.svg";